import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {CustomerDetailsPage} from 'src/customers/customer-details-page'

export const Route = createFileRoute('/_app/customers/$customerId')({
    component: CustomerDetailsRoute,
})

function CustomerDetailsRoute() {
    const {customerId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <CustomerDetailsPage customerId={customerId} />
        </Container>
    )
}
